import ComponentError from "@/components/ComponentError";
import { HeaderTextBlock } from "@/components/Typography";
import { useGetSmsHealthChecks } from "@/requests/hooks/collect";
import HealthCheck from "@/routes/Sms/HealthCheck/HealthCheck";

import HealthCheckLoading from "@/routes/Sms/HealthCheck/HealthCheckLoading";
import { useTranslation } from "react-i18next";

const HealthCheckController = () => {
  const { t } = useTranslation();

  const healthCheckHook = useGetSmsHealthChecks();
  const { isPending, isError } = healthCheckHook;

  const renderHeaderTetBlock = () => (
    <div className="mb-50">
      <HeaderTextBlock
        featureText={t("sms.healthCheck.header.feature")}
        featureTextColor="primary"
        headingText={t("sms.healthCheck.header.heading")}
        headingTextColor="secondary"
        descriptionText={t("sms.healthCheck.header.description")}
        descriptionTextColor="secondary"
        align="left"
      />
    </div>
  );

  const renderBody = () => {
    if (isPending) return <HealthCheckLoading />;

    if (isError) return <ComponentError message={t("sms.healthCheck.error")} />;

    return <HealthCheck healthChecksHook={healthCheckHook} />;
  };

  return (
    <>
      {renderHeaderTetBlock()}
      {renderBody()}
    </>
  );
};

export default HealthCheckController;
